import React from 'react';

import { sortBy } from 'lodash';

import { formatPhoneNumber, getGeoFromLocalStorage, prettifyCity } from '@/helpers/helpers';

import styles from './index.module.scss';

const SORT_ORDER = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ...[...Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i))]];

const AllListings = ({ category = {}, city = '', state = '' }) => {
  const [listings, setListings] = React.useState({});

  React.useEffect(() => {
    async function loadData() {
      setListings([]);
      try {
        const location =
          city && state
            ? `city=${city}&state_abbr=${state}`
            : getGeoFromLocalStorage().zip_code
              ? `zip_code=${getGeoFromLocalStorage().zip_code}`
              : `city=${getGeoFromLocalStorage().city}&state_abbr=${getGeoFromLocalStorage().region_code}`;
        const response = await fetch(`https://twilioproxy.elocal.com/api/listings?${location}&category_id=${category.id}&limit=1000`);
        let results = await response.json();

        // Filter out eLocal listings, any listing without a phone.
        results = (results.listings || []).filter((item) => item.display_phone && item.display_name.toLowerCase().indexOf('elocal') === -1 && !item.suppress_from_listings_page);

        // Group the listings into alphbetical order grouped by letter.
        const grouped = {};
        results.map((result) => {
          const letter = result.display_name.substring(0, 1).toUpperCase();
          if (!grouped[letter]) {
            grouped[letter] = [];
          }
          grouped[letter].push(result);
        });
        setListings(grouped);
      } catch {
        (e) => console.debug(e);
      }
    }
    loadData();
  }, [category.id, city, state]);

  return Object.keys(listings).length > 0 ? (
    <div className={styles['all-listings-container']}>
      <div className="container">
        <h2>
          {category.name} in {prettifyCity(city)}, {state.toUpperCase()}
        </h2>
        <div className={styles['all-listings-cards-container']}>
          {SORT_ORDER.map((letter) => {
            if (listings[letter]) {
              return (
                <>
                  <h3>{letter}</h3>
                  <div className={styles['all-listings-card-wrapper']}>
                    {sortBy(listings[letter], ['listing.display_name']).map((listing) => (
                      <div className={styles['all-listings-card']} key={listing.profile_id}>
                        <div className={styles['business-name']}>{listing.display_name}</div>
                        {listing.location?.address_1 && <div className={styles['address-wrapper']}>{listing.location?.address_1}</div>}
                        <div className={styles['address-wrapper']}>{listing.location?.city && listing.location?.state ? `${listing.location.city}, ${listing.location.state}` : ''}</div>
                        <div className={styles['cta-container']}>{listing.display_phone && <a href={`tel:${listing.display_phone}`}>{formatPhoneNumber(listing.display_phone)}</a>}</div>
                      </div>
                    ))}
                  </div>
                </>
              );
            }
          })}
        </div>
      </div>
    </div>
  ) : null;
};

export default AllListings;
